import mobileConstants from "../../mobile/commons/MobileFormsConstants";
import utilMobile from "../../mobile/commons/MobileGeneralFunctions";
import listService from 'ListService';
import constants from 'Constants';
class GeneralMobileAdjustments {

    getFactoryStyle(factoryKey){
        if (mobileConstants.INPUTS_FACTORY_KEYS.includes(factoryKey)) {
            return listService.getMobileStyleByKey(mobileConstants.TEXT_INPUT_FACTORY_KEY);
        }
        return 0;
    }

    adjustMobileControl(control) {
        let controlFactoryKey = control.model.get("factoryKey");
        let styles = this.getFactoryStyle(controlFactoryKey);

        let controlContainer = $(`.mobile-column-content #${control.id}`);// control.$el.find(`#${control.id}`);

        let element = controlContainer.children(".pf-control-core").first();
        utilMobile.cleanContainer(controlContainer[0]);
        this.setMobileControlGeneralStyle(control, element, controlContainer, styles);
        return element;
    }

    getMargin(controlMargin, mobileMargins) {
        if (!controlMargin || controlMargin < mobileConstants.MARGIN_DEFAULT_10) {
            return 5;
        }
        return mobileMargins;
    }

    resetMargins() {
        return {
                "top": mobileConstants.MARGIN_EMPTY_VALUE, 
                "bottom": mobileConstants.MARGIN_EMPTY_VALUE, 
                "left": mobileConstants.MARGIN_EMPTY_VALUE, 
                "right": mobileConstants.MARGIN_EMPTY_VALUE
               };
    }
    

    setContainerMargins(control, element) {
        let marginsToApply = control.model.get("~margins");
        let margins = control.model.get("margins");
        let marginSize = control.model.get("marginSize"); 
       
        if(marginsToApply){
            margins =  this.resetMargins();
        
            marginsToApply.forEach(option => {
                if(option !== "none"){
                    margins[option] = marginSize;
                }
            });

            control.model.set('margins', margins, constants.MODEL_SILENT);      
        }
        
        if(margins){
            element.css({
                "margin-bottom": `${this.getMargin(margins.bottom, marginSize)}px`,
                "margin-top": `${this.getMargin(margins.top, marginSize)}px`
            });
        }
    }

    calculateHeight(control){
        let height = control.model.get("fontSize") * mobileConstants.LINE_HEIGHT_FACTOR + 2;

        if(control.model.get("factoryKey") === "control_multiple_text_input"){
            height = height * 4; //For multiline the height should consider 4 lines
            control.model.set("height", height, constants.MODEL_SILENT)
        }


        return height >= mobileConstants.DEFAULT_HEIGHT ? height : mobileConstants.DEFAULT_HEIGHT;
    }

    setButtonsHeight(element) {

        if(element && element.length > 0){
            element.parent('.pf-control').css("height", 'auto');
            element.css("height", 'auto');
            element.css("min-height", '');
            element.css("line-height", '');
            element.css("white-space", 'normal');
            element.css("padding", '3px');
            element[0].lastElementChild.style.display = 'none';
        }
    }

    setTextsHeight(element){
        element.css("height",'auto');
    }

    setMobileControlGeneralStyle(control, element, container){
        let height = this.calculateHeight(control);

        container.addClass('control-container');

        this.setContainerMargins(control, element);
        
        element.css("width","100%");
        element.parent().css('position', 'relative');

        if (!mobileConstants.UPDATE_HEIGHT_EXCEPTION.includes(control.model.get('factoryKey'))) {
            element.css("height", `${height}`);
        }
    }
}

const mobileAdjustmentGeneral = new GeneralMobileAdjustments();
export default mobileAdjustmentGeneral;